import { render, staticRenderFns } from "./setRemark.vue?vue&type=template&id=25f05941&scoped=true"
import script from "./setRemark.vue?vue&type=script&lang=js"
export * from "./setRemark.vue?vue&type=script&lang=js"
import style0 from "./setRemark.vue?vue&type=style&index=0&id=25f05941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f05941",
  null
  
)

export default component.exports